export default {
    namespaced: true,
    state: {
        currentPage: 1,
        perPage: 20,
        totalRows: 0,
        taskInfo: [],
    },
    getters: {
        TASKS_INFO: state => {
            return state.taskInfo;
        },
        CURRENT_PAGE: state => {
            return state.currentPage;
        },
        TOTAL_ROWS: state => {
            return state.totalRows;
        },
        PER_PAGE: state => {
            return state.perPage;
        },
        AMOUNT_PAGE: (state) => {
            return Math.ceil(state.totalRows / state.perPage);
        },
        OFFSET: (state) => {
            return Math.ceil(state.perPage) * (state.currentPage - 1);
        }
    },
    mutations: {
        TASKS_INFO: (state, payload) => {
            return state.taskInfo = payload;
        },
        CURRENT_PAGE: (state, payload) => {
            return state.currentPage = payload;
        },
        TOTAL_ROWS: (state, payload) => {
            return state.totalRows = payload;
        },
        PER_PAGE: (state, payload) => {
            return state.perPage = payload;
        },
    },
    actions: {
        GET_INFO: async ({state, getters}, payload) => {
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/suppliers/task/' + payload.id + '/' + state.perPage + '/' + getters.OFFSET,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    state.taskInfo = responseData.taskInfo
                    state.totalRows = responseData.count
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                },
            });
        },
        EXCLUDE: async ({state}, payload) => {
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/suppliers/site-exclude',
                parameter: {foundId: payload.foundId},
                th: payload.th,
                showSuccessMessage: true,
                getSuccessResponse: () => {
                    payload.th.GET_INFO({th: payload.th, id: payload.th.taskId})
                    console.log(state.currentPage)
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                }
            });
        },
    }
}